import type {AgentMode} from '@github-ui/copilot-shared-ui/utils/agent-mode'

import type {McpPermissionMode} from '@github-ui/agent-sessions-types/mcp-permission-mode'

/**
 * Maps the coding-agent MCP permission mode selection to the chat runtime
 * agent mode used by `AhpProvider` / `session.commands.setMode`. Sandbox is
 * the only place these two systems meet today: the composer collects an
 * `McpPermissionMode`, and both the chat handoff and the environment-task
 * first-turn `configureSession` need to translate it to the equivalent
 * `AgentMode` for the runtime.
 *
 * - `allow_all` -> `autopilot` (skip approvals)
 * - `default`   -> `interactive` (prompt for approvals)
 * - `undefined` -> `undefined` (defer to the runtime / stored preference)
 */
export function mapMcpPermissionModeToAgentMode(mode: McpPermissionMode | undefined): AgentMode | undefined {
  if (mode === 'allow_all') return 'autopilot'
  if (mode === 'default') return 'interactive'
  return undefined
}
